import { useQuery } from "@tanstack/react-query";
import { HelpHubService } from "@/services/database/HelpHubService";
import type { HelpHubDTO, HelpHubGuideDTO } from "@/types/help-hub/help-hub";

/**
 * Public (unauthenticated) fetch of a Genie's Support Hub.
 * `data === null` means no hub — not public, or no such slug.
 */
export const usePublicHelpHub = (urlName?: string | null, enabled = true) =>
  useQuery<HelpHubDTO | null>({
    queryKey: ["public-help-hub", urlName],
    queryFn: () => HelpHubService.getPublicHub(urlName as string),
    enabled: !!urlName && enabled,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    retry: false,
  });

/** Public fetch of one published guide's readable text. */
export const usePublicHelpGuide = (
  urlName?: string | null,
  documentId?: string | null,
) =>
  useQuery<HelpHubGuideDTO | null>({
    queryKey: ["public-help-guide", urlName, documentId],
    queryFn: () =>
      HelpHubService.getPublicGuide(urlName as string, documentId as string),
    enabled: !!urlName && !!documentId,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    retry: false,
  });
